module.exports = __webpack_public_path__ + "static/media/ic_categories_game.193ad12b.svg";